import { Group, Stack, Text, Flex, Badge } from "@mantine/core"
import { PersonProfilePictureAvatar } from "../../../../-components/person-profile-picture-avatar"
import dayjs from "dayjs"
import { useElementSize } from "@mantine/hooks"
import { ellipsify } from "../../../../../../utils/ellipsify"
import { SimpleUser } from "@/orval/gen/model"
import { t } from "i18next"

interface Props {
  author: SimpleUser | null | undefined
  authorSubtext?: string
  timeStamp: string
  rightSection?: React.ReactNode
  isDraft?: boolean
}

export function PostHeader({
  author,
  authorSubtext,
  timeStamp,
  rightSection,
  isDraft,
}: Props) {
  const { ref, width } = useElementSize()

  return (
    <Group gap={"xs"} ref={ref} w={"100%"} align="center" wrap="nowrap">
      {author ? (
        <PersonProfilePictureAvatar personId={author?.personId} />
      ) : null}
      <Stack gap={0} miw={0}>
        <Text truncate>{author?.userName}</Text>
        {authorSubtext ? (
          <Text truncate size="sm" c="dimmed">
            {authorSubtext}
          </Text>
        ) : null}
      </Stack>
      <Flex justify="flex-end" flex={1} wrap="wrap">
        {isDraft ? (
          <Badge
            color="blue"
            variant="outline"
            size="sm"
            style={{ flexShrink: 0 }}
          >
            {t("Draft")}
          </Badge>
        ) : (
          <Text
            style={{ ...ellipsify, whiteSpace: undefined, textAlign: "right" }}
            size="sm"
            c="dimmed"
          >
            {dayjs(timeStamp).isSame(dayjs(), "day")
              ? dayjs(timeStamp).format("LT")
              : dayjs(timeStamp).format(width < 400 ? "L" : "ddd L")}
          </Text>
        )}
      </Flex>
      {rightSection ?? null}
    </Group>
  )
}
